import { makeQuery } from "src/queries/makeQuery";
import type { TagItem } from "src/queries/tags/tags.types";

export const useQueryTags = Object.assign(
  makeQuery<TagItem[]>("/api/tags", {
    queryParams: ["env_name"],
    enabled: (p) => !!p.env_name,
  }),
  {
    selectKeyValueByName: (tags: TagItem[]) =>
      tags.reduce<Record<string, number>>((acc, tag) => {
        acc[tag.name.toLowerCase()] = tag.tag_id;
        return acc;
      }, {}),
  }
);
